import { isComboPackage } from './promotionTypes'

/**
 * @description 套餐类活动（promotionType=4/5）行上解析活动编码
 * @param {Record<string, unknown>} row
 * @returns {string|number|null|undefined}
 */
function rowPromotionCode(row) {
  if (row == null || typeof row !== 'object') return null
  // 兼容 promotionId（旧版）和 promotionCode（新版）
  const v = row.promotionCode ?? row.promotion_code ?? row.promotionId ?? row.promotion_id
  if (v === undefined || v === null || v === '') return null
  return v
}

/**
 * @description 套餐类活动实例键：与活动类型、活动编码同级的 `comboKey`
 * - 缺失时按空串参与比较，兼容旧数据
 * @param {Record<string, unknown>} row
 * @returns {string}
 */
function rowComboInstanceKey(row) {
  if (row == null || typeof row !== 'object') return ''
  const v = row.comboKey ?? row.combo_key ?? row.comboInstanceKey
  if (v === undefined || v === null || v === '') return ''
  return String(v)
}

/**
 * @description 套餐类活动（搭配套餐4/组合促销5）唯一分组键
 * - 三者一致才为同一购物车/订单套餐实例：promotionType + promotionCode + comboKey
 * @param {Record<string, unknown>} row
 * @returns {string|null} 非套餐类或缺少 promotionCode 时返回 null
 */
export function comboPackageGroupKeyFromRow(row) {
  if (!isComboPackage(row?.promotionType ?? row?.promotion_type)) return null
  const pid = rowPromotionCode(row)
  if (pid == null || pid === '') return null
  const pt = Number(row?.promotionType ?? row?.promotion_type)
  return `${pt}:${String(pid)}:${rowComboInstanceKey(row)}`
}

/**
 * @description 两行是否属于同一套餐类活动实例
 * @param {Record<string, unknown>} a
 * @param {Record<string, unknown>} b
 * @returns {boolean}
 */
export function isSameComboPackageGroup(a, b) {
  const ka = comboPackageGroupKeyFromRow(a)
  const kb = comboPackageGroupKeyFromRow(b)
  if (ka == null || kb == null) return false
  return ka === kb
}

// ========== 兼容旧版函数名 ==========

/**
 * @description 套餐类活动唯一分组键
 * @deprecated 请使用 comboPackageGroupKeyFromRow，支持 type=4/5
 * @param {Record<string, unknown>} row
 * @returns {string|null}
 */
export function type3PackageGroupKeyFromRow(row) {
  return comboPackageGroupKeyFromRow(row)
}

/**
 * @description 两行是否属于同一套餐活动实例（兼容旧版）
 * @deprecated 请使用 isSameComboPackageGroup
 * @param {Record<string, unknown>} a
 * @param {Record<string, unknown>} b
 * @returns {boolean}
 */
export function isSameType3PackageGroup(a, b) {
  return isSameComboPackageGroup(a, b)
}
